import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import Icon from "../../../icons/components/Icon";
import { BUTTON_TYPES } from "../../constants.web";
const useStyles = makeStyles()((theme) => {
    return {
        button: {
            backgroundColor: "#4b6790",
            color: "#FFFFFF",
            borderRadius: 6,
            padding: "10px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: 0,
            // ...withPixelLineHeight(theme.typography.bodyShortBold),
            transition: "background .2s",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: "#4687ED",
            },
            "&:active": {
                backgroundColor: "#0045B3",
            },
            "&.focus-visible": {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${"#4687ED"}`,
            },
            "& div > svg": {
                fill: "#FFF",
            },
        },
        primary: {},
        secondary: {
            backgroundColor: "#E0E0E0",
            color: "#040404",
            "&:hover": {
                backgroundColor: "#FFF",
            },
            "&:active": {
                backgroundColor: "#C2C2C2",
            },
            "& div > svg": {
                fill: "#040404",
            },
        },
        tertiary: {
            backgroundColor: "transparent",
            color: "#4b6790",
            "&:hover": {
                backgroundColor: "#e5eef9",
            },
            "&:active": {
                backgroundColor: "#d1e3f6",
            },
        },
        destructive: {
            backgroundColor: "#CB2233",
            "&:hover": {
                backgroundColor: "#D83848",
            },
            "&:active": {
                backgroundColor: "#A21B29",
            },
        },
        disabled: {
            backgroundColor: "#C2C2C2",
            color: "#858585",
            "&:hover": {
                backgroundColor: "#C2C2C2",
                color: "#858585",
            },
            "&:active": {
                backgroundColor: "#C2C2C2",
                color: "#858585",
            },
            "& div > svg": {
                fill: "#858585",
            },
        },
        iconButton: {
            padding: 8,
        },
        textWithIcon: {
            marginLeft: 8,
        },
        small: {
            padding: "8px 16px",
            // ...withPixelLineHeight(theme.typography.labelBold),
            "&.iconButton": {
                padding: 4,
            },
        },
        medium: {},
        large: {
            padding: "13px 16px",
            // ...withPixelLineHeight(theme.typography.bodyShortBoldLarge),
            "&.iconButton": {
                padding: "12px",
            },
        },
        fullWidth: {
            width: "100%",
        },
    };
});
const Button = React.forwardRef(({ accessibilityLabel, autoFocus = false, className, disabled, fullWidth, icon, id, isSubmit, label, labelKey, onClick = () => null, onKeyPress = () => null, size = "medium", testId, type = BUTTON_TYPES.PRIMARY, }, ref) => {
    const { classes: styles, cx } = useStyles();
    const { t } = useTranslation();
    return (React.createElement("button", Object.assign({ "aria-label": accessibilityLabel, autoFocus: autoFocus, className: cx(styles.button, styles[type], disabled && styles.disabled, icon &&
            !(labelKey || label) &&
            `${styles.iconButton} iconButton`, styles[size], fullWidth && styles.fullWidth, className), "data-testid": testId, disabled: disabled }, (id ? { id } : {}), { onClick: onClick, onKeyPress: onKeyPress, ref: ref, title: accessibilityLabel, type: isSubmit ? "submit" : "button" }),
        icon && React.createElement(Icon, { size: 24, src: icon }),
        (labelKey || label) && (React.createElement("span", { className: icon ? styles.textWithIcon : "" }, labelKey ? t(labelKey) : label))));
});
export default Button;
